<template>
  <div class="com">
    <div class="txt">
      <br>
      <h4 class="subTitle" v-if="kit">KIT ID: {{ convertKitId(this.kit) }}</h4> <br>
      All fields are required
    </div>
    <div class="form-wrap">
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          v-validate="'required|max:50'"
          placeholder="First Name"
          name="first_name"
          maxlength="50"
          @change="changeVal('first_name', $event, first_name_count)"
          @focus="removeCaps('first_name', $event, 'focus')"
          v-on:keyup.delete="removeCaps('first_name', $event,'delete')"
          v-model="first_name"
          @focusout="onFocusOut"
        />
        <span class="validate-error" v-if="errors.has('first_name')">
          {{ errors.first("first_name") }}
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          maxlength="50"
          placeholder="Last Name"
          name="last_name"
          v-validate="'required|max:50'"
          @change="changeVal('last_name', $event, last_name_count)"
          @focus="removeCaps('last_name', $event, 'focus')"
          v-on:keyup.delete="removeCaps('last_name', $event, 'delete')"
          v-model="last_name"
          @focusout="onFocusOut"
        />
        <span class="validate-error" v-if="errors.has('last_name')">
          {{ errors.first("last_name") }}
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input toLowerCase"
          placeholder="Email"
          name="email"
          v-validate="'required|email|email_exist'"
          :class="{ invalid: errors.has('email') }"
          v-model="email"
          @focusout="onFocusOut"
        />
        <span class="validate-error" v-if="errors.has('email')">
          <template v-if='errors.first("email") === "email already exist" || errors.first("email") === "Email already exist"'>
            Email already in use. Please <router-link to="/login" tag="a" class="signin-link">login</router-link> to activate your kit.
          </template>
          <template v-else>
            {{errors.first("email")}}
          </template>
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="text"
          v-mask="'(###) ### - ####'"
          class="input"
          placeholder="Mobile Phone"
          name="phone"
          v-validate="
            'regex:^\\(([0-9]{3})\\)\\s([0-9]{3})\\s[-]\\s([0-9]{4})$|required|phone_exist'
          "
          v-model="phone"
          @focusout="onFocusOut"
        />
        <span class="validate-error" v-if="errors.has('phone')">
            {{errors.first("phone")}}
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="password"
          class="input"
          name="passwordProfile"
          v-validate="'required|min:8'"
          placeholder="Password"
          v-model="password"
        />
        <span class="validate-error pass" v-if="errors.has('passwordProfile')">
          {{ errors.first("passwordProfile") }}
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="password"
          class="input"
          name="verifyPassword"
          placeholder="Verify Password"
          v-validate="'required|is:' + password"
          v-model="verifyPassword"
        />
        <span class="validate-error" v-if="errors.has('verifyPassword')">
          {{ errors.first("verifyPassword") }}
        </span>
      </div>
      <button
        class="btn"
        @click.prevent="$validator.validateAll()"
        @click="switchStep"
        :disabled="!isComplete"
      >
        Continue
      </button>
      <div class="have-kit inside">
          Already have an account?
          <router-link to="/login" tag="a" class="haveAccount-link">
             Sign in </router-link
          >
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";

export default {
  name: "CreateProfileV2",
  mixins: [parseAndConvertKitId],
  directives: { mask },
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      password: "",
      verifyPassword: "",
      last_name_count: 0,
      first_name_count: 0,
      kit: ""
    };
  },
  computed: {
    ...mapGetters(["userInfo", "serverValidation", "back", "fullname"]),
    isComplete() {
      return !!(
        this.first_name &&
        this.last_name &&
        this.email &&
        this.phone &&
        this.password &&
        this.verifyPassword
      );
    }
  },
  watch: {
    userInfo(n) {
      if (n.collected_email !== null) {
        this.email = n.collected_email;
      }
      this.first_name = n.collected_first_name;
      this.last_name = n.collected_last_name;
      this.kit = n.kit_id;
    },
    serverValidation(error) {
      this.$validator.errors.clear();
      error.forEach(item => {
        if(item.field != null) {
          this.$validator.errors.add({ field: item.field, msg: item.message });
        }
      });
    }
  },
  methods: {
    ...mapActions(["sendUserInfo", "saveNumber", "saveFormPwd", "checkKitId", "sendTempUserInfo"]),
    ...mapMutations(["userFullName", "clearServerValidationErrors"]),
    removeCaps(model, e, type) {
      if (type == 'focus') {
        let val = 0;
        if (e.target.value.length > 0) {
          val = 1;
        }
        if (model == "first_name") {
          this.first_name_count = val;
        } else if (model == "last_name") {
          this.last_name_count = val;
        }
      } else if (e.target.value.length == 0) {
        if (model == "first_name" && this.first_name_count == 0) {
          this.first_name_count = this.first_name_count + 1;
        } else if (model == "last_name" && this.last_name_count == 0) {
          this.last_name_count = this.last_name_count + 1;
        }
      }
    },
    changeVal(model, e, count) {
      if (count == 0 && e.target.value.length > 0) {
        e.target.value = this.capitalizeVal(e.target.value);
        e.target.style.textTransform = 'none';
      }
      this[model] = e.target.value;
    },
    switchStep() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      const user = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email.toLocaleLowerCase(),
        phone: `1${this.phone.replace(/[\s-()+]/g, "")}`,
        password: this.password,
        password_confirmation: this.verifyPassword,
        kit_id: this.kit,
        kit_id_confirmation: this.kit
      };
      this.sendUserInfo(user).then(res => {
        this.userFullName({
          first_name: res.data.data.user.first_name,
          last_name: res.data.data.user.last_name
        });
        this.$emit("nextStep", 1);
      });
      const contacts = {
        phone:
          this.phone.replace(/[\s-()+]/g, "")[0] === "1"
            ? this.phone.replace(/[\s-()+]/g, "")
            : `1${this.phone.replace(/[\s-()+]/g, "")}`,
        mail: this.email.toLocaleLowerCase()
      };
      this.saveNumber(contacts);
      const tempPwd = {
        password: this.password,
        verifyPassword: this.password
      };
      this.saveFormPwd(tempPwd);
    },
    prev() {
      this.$emit("prevStep", 1);
    },
    capitalizeVal(input) {
      return input
        ? input.replace(/^\w{1,}|\w{4,}/g, function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
          })
        : input;
    },
    onFocusOut() {
      const user = {
        first_name: this.first_name || '',
        last_name: this.last_name || '',
        email: this.email.toLocaleLowerCase(),
        phone: `1${this.phone.replace(/[\s-()+]/g, "")}`,
        kit_id: this.kit,
      };
      this.sendTempUserInfo(user);
    }
  },
  mounted() {
    const tempuser = this.$store.getters.gettestuser;

    if (typeof tempuser !== 'undefined' && Object.keys(tempuser).length > 0) {
      this.first_name = tempuser.first_name;
      this.last_name = tempuser.last_name;
      this.email = tempuser.email;
      this.phone = tempuser.phone.substring(1);
    } else {
      this.email = this.$store.getters.contactsEmail;
      this.phone = this.$store.getters.contactsPhone.substring(1);
      this.first_name = this.$store.getters.userInfo.first_name;
      this.last_name = this.$store.getters.userInfo.last_name;
    }
    if (localStorage.getItem("actkitid")) {
      this.kit = localStorage.getItem("actkitid");
      const kitId = {
        kit_id: this.parseKitId(this.kit),
        kit_id_confirmation: this.parseKitId(this.kit)
      };
      this.checkKitId(kitId).then(res => {
        const contacts = {
          phone: "",
          mail: ""
        };
        this.saveNumber(contacts);
        this.clearServerValidationErrors();
      });
      localStorage.removeItem("actkitid");
    } else {
      this.kit = this.$store.getters.userInfo.kit_id;
    }

    this.password = this.$store.getters.tempPwd;
    this.verifyPassword = this.$store.getters.tempPwd;
    if (this.back === true && this.fullname !== null) {
      this.first_name = this.fullname.first_name;
      this.last_name = this.fullname.last_name;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}

.com {
  margin: 20px 0 0 0;
}

.txt {
  color: $blue;
  margin: -15px 0 20px;
  font-size: 14px;
  text-align: center;
  font-family: TTNormsLight, sans-serif;
}
.input {
  padding: 15px 20px;
  color: $gray;
  width: 100%;
  margin-bottom: 5px;
  font-size: 16px;
  border-radius: 10px;
  text-align: center;
  border: 1px solid #cccccc;
  font-family: TTNormsMedium, sans-serif;
  outline: none;
}

.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-transform: capitalize;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input-wrap {
  margin: 0 0 20px;
}

.input.invalid {
  border: 1px solid $red;
}

.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.have-kit {
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: TTNormsMedium, sans-serif;
  color: $green;
  margin-top: 36px;
}
.haveAccount-link {
  color: $green;
  margin-left: 10px;
  font-family: TTNormsMedium, sans-serif;
}
.signin-link {
  color: #005eb8;
}
.subTitle {
    font-size: 16px;
    color: #005eb8;
    font-family: TTNormsRegular, sans-serif;
    font-weight: bold;
}
</style>
